//
// Temp workaround:
//
// Empty file to prevent errors when importing beans in stencil apps
// Stencil apps with React bindings will not work
//
// Must be fixed
//
